import usePosOrderResetHook from "@/shared/hooks/usePosOrderResetHook";
import IconButton from "../IconButton/IconButton";
import PosTakeoutButton from "./PosTakeoutButton";
import {
  useIsTableAndHasSession,
  useIsTableOrderEditing,
} from "@/shared/hooks/usePosOrderTableSessionHook";
import usePosOrderDeliveryMethod from "@/shared/atoms/usePosOrderDeliveryMethodAtom";
import { DeliveryMethods } from "@/shared/utils/enum";

const PosCartPosMenu = () => {
  const reset = usePosOrderResetHook();
  const isTableOrderEditing = useIsTableOrderEditing();
  const isTableAndHasSession = useIsTableAndHasSession();
  const [deliveryMethod] = usePosOrderDeliveryMethod();

  const showTakeoutButton =
    isTableAndHasSession || deliveryMethod === DeliveryMethods.POS_ORDER;

  return (
    <div className="flex flex-[0_0_auto] overflow-hidden items-center justify-between bg-white px-4 py-6 pr-10 border-b-2 border-border/50">
      <IconButton
        onClick={() => {
          reset(false, false, isTableOrderEditing ? false : true);
        }}
        variants="arrowLeft"
        size="small"
      />

      {showTakeoutButton && <PosTakeoutButton />}
    </div>
  );
};

export default PosCartPosMenu;
